import React from 'react';
import { twMerge } from 'tailwind-merge';
interface SegmentedProgressProps {
  completed: number;
  total: number;
  className?: string;
  tone?: 'brand' | 'emerald';
}
export function SegmentedProgress({
  completed,
  total,
  className,
  tone = 'brand'
}: SegmentedProgressProps) {
  const segments = Array.from({
    length: Math.max(total, 1)
  });
  const fill = tone === 'emerald' ? 'bg-emerald-500' : 'bg-brand-600';
  return <div className={twMerge('flex items-center gap-1.5', className)} role="progressbar" aria-valuemin={0} aria-valuemax={total} aria-valuenow={completed} aria-label={`${completed} of ${total} calls complete`} data-id="element-396" data-mp="1dbp3zn0vkn3j">
      {segments.map((_, i) => <span key={i} className={twMerge('h-2 flex-1 rounded-full transition-colors duration-300', i < completed ? fill : 'bg-ink-200')} data-id="element-397" data-mp="1i8yz9jay3sza" data-mpi={i} />)}
    </div>;
}